import app from './app';
import { CUSTOMERENTITY_SERVICE_URL } from '../../libs/constants';

const getAllCustomerEntity = (userId, requestData) => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));

        const headerConfig = { headers: { "DRS-Fetch-Type": "getCustomerEntities" } };
        const response = await api.post(`${CUSTOMERENTITY_SERVICE_URL}/getCustomerEntities/${userId}`, requestData , headerConfig);

        dispatch(app.setLoading(false));
        dispatch({ type: "SET_CUSTOMER_ENTITY_LIST", data: response.data });
    } catch (error) {
        dispatch(app.setLoading(false));
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
};

const getCustomerEntityDetails = (userId, orgId) => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));

        const headerConfig = { headers: { "DRS-Fetch-Type": "getCustomerLegalEntities" } };
        const response = await api.post(`${CUSTOMERENTITY_SERVICE_URL}/getCustomerLegalEntities/${userId}/${orgId}`, {}, headerConfig);

        dispatch(app.setLoading(false));
        dispatch({ type: "SET_CUSTOMER_ENTITY_DETAILS", data: response.data });
    } catch (error) {
        dispatch(app.setLoading(false));
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
    }
};

const createCustomerEntity = (requestData = {}) => async (dispatch, getState, api) => {
    console.log(requestData,"CREATE");
    dispatch(app.setLoading(true));
    const headerConfig = { headers: { "DRS-Fetch-Type": "createCustomerLegalEntities" } };

    await api.post(CUSTOMERENTITY_SERVICE_URL +"/createCustomerLegalEntities", requestData, headerConfig)
        .then(response => {
            dispatch(app.setLoading(false));
            dispatch({type: "SET_FORM_INVALID", data: false});
            dispatch({ type: "SET_CUSTOMERENTITY_CREATION_STATUS", data: "SUCCESS" });
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            const errorData = error.response && error.response.data ? error.response.data : {};
            const { errorCode, message } = errorData;

            if (errorCode === 500 && message === "Customer already exists with Org id") {
                dispatch(app.setAppModal({ type: "error", messageId: "customer_exists_for_orgid" }));
                dispatch({ type: "SET_CUSTOMERENTITY_CREATION_STATUS", data: "ERROR" });
            }
            else {
                dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
                dispatch({ type: "SET_CUSTOMERENTITY_CREATION_STATUS", data: "ERROR" });
            }            
        });
};

const updateCustomerEntity = (requestData = {}) => async (dispatch, getState, api) => {
    console.log(requestData,"UPDATE");
    dispatch(app.setLoading(true));
    const headerConfig = { headers: { "DRS-Fetch-Type": "createCustomerLegalEntities" } };

    await api.post(CUSTOMERENTITY_SERVICE_URL +"/createCustomerLegalEntities", requestData, headerConfig)
        .then(response => {
            dispatch(app.setLoading(false));
            dispatch({type: "SET_FORM_INVALID", data: false});
            dispatch({ type: "SET_CUSTOMERENTITY_UPDATE_STATUS", data: "SUCCESS" });
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
            dispatch({ type: "SET_CUSTOMERENTITY_UPDATE_STATUS", data: "ERROR" });
        });
};

const updateCustomerEntityField = (data) => {
    return {
        type: 'UPDATE_CUSTOMER_ENTITY_FIELDS_DATA',
        data
    }
};

const addLegalEntityRow = (defaultCountryMapingRow) => {
    return {
        type: 'ADD_LEGALENTITY_ROW',
        defaultCountryMapingRow
    }
};

const setLegalEntityColumnValue = (columnName, columnValue, rowIndex) => {
    return {
        type: 'SET_LEGALENTITY_COLUMN_VALUE',
        columnName,
        columnValue,
        rowIndex
    }
};

const deleteLegalEntityRow = (rowIndex) => {
    return {
        type: 'DELETE_LEGALENTITY_ROW',
        rowIndex
    }
};

const resetLegalEntityDetails = () => {
    return { type: 'RESET_LEGALENTITY_DATA' };
};

const updateAddressCountry = (country) => {
    return {
        type: 'UPDATE_ADDRESS_COUNTRY',
        country
    }
}

export default {
    getAllCustomerEntity,
    addLegalEntityRow,
    setLegalEntityColumnValue,
    deleteLegalEntityRow,
    resetLegalEntityDetails,
    updateCustomerEntityField,
    getCustomerEntityDetails,
    createCustomerEntity,
    updateCustomerEntity,
    updateAddressCountry
}